import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
  editCupom,
  fetchCategoriesByName,
  fetchProductsByName,
  fetchCupomId,
  fetchStores,
  fetchUsers,
  postCupom
} from '../../../redux/actions/coupon';
import {
  Wrapper,
  Col1,
  Title,
  DivButtonSave,
  SaveButton,
  Card,
  SubTitle,
  H4,
  Field,
  Row,
  CustomLabel,
  CheckboxWrapper,
  SubCard,
  RadioGroup,
  Div,
  FieldWrapper,
  Span,
  NewHoursButton,
  Table,
  Thead,
  Tbody,
  Td,
  Th,
  Tr,
  Strong,
  CustomIcon,
  Caption
} from './style';
import { useDispatch } from 'react-redux';
import {
  CheckboxHours,
  DateInput,
  Icon,
  Input,
  Loading,
  TimeInputHours
} from '../../../components/common';
import { RadioButton, SelectInput } from 'vqp-common';
import CustomAutoComplete from '../../../components/common/Autocomplete';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { getStoreInfo } from '../../../utils/storeInfo';
import CoupousInfo from './InfoModal/CoupousInfo';
import { PercentageNumeric } from '../../../components/common/PercentageNumeric';
import { CurrencyNumeric } from '../../../components/common/CurrencyNumerics';
import { useStore } from '../../../providers/store.provider';

const CouponsCreatePage = (props) => {
  const dispatch = useDispatch();
  const storeProvider = useStore();

  const selectedMultistore = storeProvider.selectedMultistore?.id;

  const [loading, setLoading] = useState(false);
  const [searchUsers, setSearchUsers] = useState([]);
  const [searchCategories, setSearchCategories] = useState([]);
  const [searchProducts, setSearchProducts] = useState([]);
  const [searchStores, setSearchStores] = useState([]);
  const [disabledButton, setDisabledButton] = useState(false);
  const [name, setName] = useState(null);
  const [qtdTotal, setQtdTotal] = useState(null);
  const [totalUser, setTotalUser] = useState(null);
  const [dateExpiration, setDateExpiration] = useState(null);
  const [firstUse, setfirstUse] = useState(null);
  const [visible, setVisible] = useState(false);
  const [typeCupom, setTypeCupom] = useState(false);
  const [cupomValue, setCupomValue] = useState('000');
  const [cupomValuePercentage, setCupomValuePercentage] = useState('0');
  const [valueMin, setValueMin] = useState('000');
  const [valueMax, setValueMax] = useState('000');
  const [description, setDescription] = useState(null);
  const [availableUsers, setAvailableUsers] = useState(true);
  const [userMay, setUserMay] = useState(false);
  const [categoryMay, setCategoryMay] = useState(false);
  const [productMay, setProductMay] = useState(false);
  const [userWillNotBeAble, setUserWillNotBeAble] = useState(false);
  const [categoryWillNotBeAble, setCategoryWillNotBeAble] = useState(false);
  const [productWillNotBeAble, setProductWillNotBeAble] = useState(false);
  const [emails, setEmails] = useState([]);
  const [availableEstablishments, setAvailableEstablishments] = useState(true);
  const [establishments, setEstablishments] = useState([]);
  const [availableHours, setAvailableHours] = useState(true);
  const [availableCategories, setAvailableCategories] = useState(true);
  const [categories, setCategories] = useState([]);
  const [availableProducts, setAvailableProducts] = useState(true);
  const [products, setProducts] = useState([]);
  const [availableModality, setAvailableModality] = useState(true);
  const [checkSegunda, setCheckSegunda] = useState(false);
  const [checkTerca, setCheckTerca] = useState(false);
  const [checkQuarta, setCheckQuarta] = useState(false);
  const [checkQuinta, setCheckQuinta] = useState(false);
  const [checkSexta, setCheckSexta] = useState(false);
  const [checkSabado, setCheckSabado] = useState(false);
  const [checkDomingo, setCheckDomingo] = useState(false);
  const [openErrorHours, setOpenErrorHours] = useState(false);
  const [openSubmitSuccess, setOpenSubmitSuccess] = useState(false);
  const [openHours, setOpenHours] = useState(null);
  const [closeHours, setCloseHours] = useState(null);
  const [restrictionHours, setRestrictionHours] = useState([]);
  const [checkTakeAlong, setCheckTakeAlong] = useState(false);
  const [checkToReceive, setCheckToReceive] = useState(false);
  const [checkDelivery, setCheckDelivery] = useState(false);
  const [checkEatHere, setCheckEatHere] = useState(false);
  const [checkKilo, setCheckKilo] = useState(false);
  const [discountCheckTakeAlong, setDiscountCheckTakeAlong] = useState(false);
  const [discountCheckToReceive, setDiscountCheckToReceive] = useState(false);
  const [discountCheckDelivery, setDiscountCheckDelivery] = useState(false);
  const [typeValueCupomAlong, setTypeValueCupomAlong] = useState(null);
  const [typeValueCupomReceive, setTypeValueCupomReceive] = useState(null);
  const [typeValueCupomDelivery, setTypeValueCupomDelivery] = useState(null);
  const [valueAlong, setValueAlong] = useState(null);
  const [valueReceive, setValueReceive] = useState(null);
  const [valueDelivery, setValueDelivery] = useState(null);
  const [valueMinAlong, setValueMinAlong] = useState(null);
  const [valueMinReceive, setValueMinReceive] = useState(null);
  const [valueMinDelivery, setValueMinDelivery] = useState(null);
  const [valueMaxAlong, setValueMaxAlong] = useState(null);
  const [valueMaxReceive, setValueMaxReceive] = useState(null);
  const [valueMaxDelivery, setValueMaxDelivery] = useState(null);
  const [cupomId, setCupomId] = useState(null);
  const [valueTab, setValueTab] = useState(0);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [message, setMessage] = useState(null);
  const storeInfo = getStoreInfo();

  const optionsFirstUse = [
    {
      value: 1,
      name: 'Nenhum'
    },
    {
      value: 2,
      name: 'Aplicativo'
    },
    {
      value: 3,
      name: 'Estabelecimento'
    }
  ];
  const optionsType = [
    {
      value: 1,
      name: 'Absoluto'
    },
    {
      value: 2,
      name: 'Porcentagem'
    }
  ];

  useEffect(() => {
    const stateId = props.location.state ? props.location.state.id : null;
    setCupomId(stateId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    async function getCupomId() {
      try {
        setLoading(true);
        const response = await dispatch(fetchCupomId(cupomId));
        const responseCupomId = response.data;

        const formatedValueMin = responseCupomId.valueMin ? responseCupomId.valueMin.toLocaleString('pt-br', {
          minimumFractionDigits: 2
        }) : "000";
        const formatedValueMax = responseCupomId.valueMax ? responseCupomId.valueMax.toLocaleString('pt-br', {
          minimumFractionDigits: 2
        }) : "000";
        const formatedCupomValue = responseCupomId.value ? responseCupomId.value.toLocaleString('pt-br', {
          minimumFractionDigits: 2
        }) : "000";

        if (responseCupomId) {
          setName(responseCupomId.name);
          setQtdTotal(responseCupomId.qtdTotal);
          setTotalUser(responseCupomId.totalUser);
          setValueMin(formatedValueMin);
          setValueMax(formatedValueMax);
          setDateExpiration(new window.Date(responseCupomId.dateExpiration));
          if (responseCupomId.firstUse) {
            if (responseCupomId.firstUse === 1) setfirstUse(0);
            if (responseCupomId.firstUse === 2) setfirstUse(1);
          }
          setVisible(responseCupomId.visible);
          setDescription(responseCupomId.description);
          if (responseCupomId.typeCupom) {
            if (responseCupomId.typeCupom === 1) setTypeCupom(0);
            if (responseCupomId.typeCupom === 2) setTypeCupom(1);
          }
          if (responseCupomId.typeCupom === 1) setCupomValue(formatedCupomValue);
          if (responseCupomId.typeCupom === 2) setCupomValuePercentage(responseCupomId.value);
          if (responseCupomId.restrictionHours) {
            setAvailableHours(true);
            handleAvailableHoursCheck('false');
            setRestrictionHours(responseCupomId.restrictionHours);
          }
          if (responseCupomId.restrictionUsers && responseCupomId.restrictionUsers.length > 0) {
            setAvailableUsers(false);
            handleAvailableCheck(false);
            setEmails(responseCupomId.restrictionUsers);
          }
          if (
            responseCupomId.restrictionEstablishments &&
            responseCupomId.restrictionEstablishments.length > 0
          ) {
            setAvailableEstablishments(false);
            handleAvailableEstablishmentsCheck(false);
            setEstablishments(responseCupomId.restrictionEstablishments);
          }

          if (responseCupomId.restrictionProducts && responseCupomId.restrictionProducts.length > 0) {
            setAvailableProducts(false);
            handleAvailableProductsCheck(false);
            setProducts(responseCupomId.restrictionProducts);
            if (responseCupomId.restrictionProductsStatus) setProductMay(true);
            if (!responseCupomId.restrictionProductsStatus) setProductWillNotBeAble(true);
          }
          if (
            responseCupomId.restrictionCategories &&
            responseCupomId.restrictionCategories.length > 0
          ) {
            handleAvailableCategoriesCheck(false);
            setAvailableCategories(false);
            setCategories(responseCupomId.restrictionCategories);
            if (responseCupomId.restrictionCategoriesStatus) setCategoryMay(true);
            if (!responseCupomId.restrictionCategoriesStatus) setCategoryWillNotBeAble(true);
          }
          if (responseCupomId.flagUser) {
            setUserMay(true);
          }
          if (!responseCupomId.flagUser) {
            setUserWillNotBeAble(true);
          }
          // if(responseCupomId.takeAlong){
          //   handleChangeAlonge(true)
          //   if(!responseCupomId.takeAlong.onlyRestriction){
          //     setTypeValueCupomAlong(responseCupomId.takeAlong.cupomType)
          //   }
          // }
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
        console.error('Erro ao buscar cupom por id', e);
      }
    }
    if (cupomId) {
      getCupomId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cupomId]);

  const clearForm = () => {
    setName('');
    setQtdTotal('');
    setTotalUser('');
    setDateExpiration('');
    setfirstUse('');
    setVisible(false);
    setTypeCupom(false);
    setCupomValue('000');
    setValueMin('000');
    setValueMax('000');
    setDescription('');
    setAvailableUsers(true);
    setUserMay(false);
    setUserWillNotBeAble(false);
    setEmails([]);
    setAvailableEstablishments(true);
    setEstablishments([]);
    setAvailableHours(true);
    setAvailableCategories(true);
    setCategories('');
    setAvailableProducts(true);
    setProducts('');
    setAvailableModality(true);
    setCheckSegunda(false);
    setCheckTerca(false);
    setCheckQuarta(false);
    setCheckQuinta(false);
    setCheckSexta(false);
    setCheckSabado(false);
    setCheckDomingo(false);
    setRestrictionHours([]);
    setCheckTakeAlong(false);
    setCheckToReceive(false);
    setCheckDelivery(false);
    setCheckEatHere(false);
    setCheckKilo(false);
    setDiscountCheckTakeAlong(false);
    setDiscountCheckToReceive(false);
    setDiscountCheckDelivery(false);
    setTypeValueCupomAlong('');
    setTypeValueCupomReceive('');
    setTypeValueCupomDelivery('');
    setValueAlong('');
    setValueReceive('');
    setValueDelivery('');
    setValueMinAlong('');
    setValueMinReceive('');
    setValueMinDelivery('');
    setValueMaxAlong('');
    setValueMaxReceive('');
    setValueMaxDelivery('');
  };

  const handleCheckVisible = ({ checked }) => {
    setVisible(checked);
  };

  const handleCheckMay = ({ checked }) => {
    setUserMay(checked);
    setUserWillNotBeAble(false);
  };

  const handleUserWillNotBeAble = ({ checked }) => {
    setUserWillNotBeAble(checked);
    setUserMay(false);
  };

  const handleChangeCategoryMay = ({ checked }) => {
    setCategoryMay(checked);
    setCategoryWillNotBeAble(false);
  };

  const handleCategoryWillNotBeAble = ({ checked }) => {
    setCategoryWillNotBeAble(checked);
    setCategoryMay(false);
  };

  const handleChangeProductMay = ({ checked }) => {
    setProductMay(checked);
    setProductWillNotBeAble(false);
  };

  const handleProductWillNotBeAble = ({ checked }) => {
    setProductWillNotBeAble(checked);
    setProductMay(false);
  };


  const handleDateChange = (inputValue) => {
    setDateExpiration(inputValue);
  };

  const handleAvailableCheck = (value) => {
    if (value === 'true' && availableUsers !== true) {
    } else if (value === 'false' && availableUsers !== false) {
      setAvailableUsers(false);
    }
  };


  const handleAvailableEstablishmentsCheck = (value) => {
    if (value === 'true' && availableEstablishments !== true) {
      setAvailableEstablishments(true);
    } else if (value === 'false' && availableEstablishments !== false) {
      setAvailableEstablishments(false);
    }
  };

  const handleAvailableHoursCheck = (value) => {
    if (value === 'true' && availableHours !== true) {
      setAvailableHours(true);
    } else if (value === 'false' && availableHours !== false) {
      setAvailableHours(false);
    }
  };


  const handleChangeSegunda = ({ checked }) => {
    setCheckSegunda(checked);
  };

  const handleChangeTerca = ({ checked }) => {
    setCheckTerca(checked);
  };

  const handleChangeQuarta = ({ checked }) => {
    setCheckQuarta(checked);
  };

  const handleChangeQuinta = ({ checked }) => {
    setCheckQuinta(checked);
  };

  const handleChangeSexta = ({ checked }) => {
    setCheckSexta(checked);
  };

  const handleChangeSabado = ({ checked }) => {
    setCheckSabado(checked);
  };

  const handleChangeDomingo = ({ checked }) => {
    setCheckDomingo(checked);
  };

  const handleChangeAlonge = ({ checked }) => {
    setCheckTakeAlong(checked);
  };

  const handleChangeReceive = ({ checked }) => {
    setCheckToReceive(checked);
  };

  const handleChangeDelivery = ({ checked }) => {
    setCheckDelivery(checked);
  };

  const handleChangeEatHere = ({ checked }) => {
    setCheckEatHere(checked);
  };

  const handleChangeKilo = ({ checked }) => {
    setCheckKilo(checked);
  };

  const handleChangeDiscontAlonge = ({ checked }) => {
    setDiscountCheckTakeAlong(checked);
  };

  const handleChangeDiscontReceive = ({ checked }) => {
    setDiscountCheckToReceive(checked);
  };

  const handleChangeDiscontDelivery = ({ checked }) => {
    setDiscountCheckDelivery(checked);
  };

  const handleCloseError = () => {
    setOpenErrorHours(false);
  };

  const handleCloseSuccess = () => {
    setOpenSubmitSuccess(false);
  };

  const handleAvailableCategoriesCheck = (value) => {
    if (value === 'true' && availableCategories !== true) {
      setAvailableCategories(true);
    } else if (value === 'false' && availableCategories !== false) {
      setAvailableCategories(false);
    }
  };

  const handleAvailableProductsCheck = (value) => {
    if (value === 'true' && availableProducts !== true) {
      setAvailableProducts(true);
    } else if (value === 'false' && availableProducts !== false) {
      setAvailableProducts(false);
    }
  };

  const handleAvailableModalityCheck = (value) => {
    if (value === 'true' && availableModality !== true) {
      setAvailableModality(true);
    } else if (value === 'false' && availableModality !== false) {
      setAvailableModality(false);
    }
  };

  const handleFrom = ({ e }) => {
    setOpenHours(e.target.value);
  };

  const handleTo = ({ e }) => {
    setCloseHours(e.target.value);
  };

  const clearFormRestrictionHours = () => {
    setOpenHours('');
    setCloseHours('');
  };

  const mappedObj = (week) => {
    return {
      dayWeek: week,
      openHour: openHours,
      closeHour: closeHours
    };
  };

  const handleAddRestrictionHors = () => {
    const weeks = restrictionHours;
    if (checkSegunda) {
      const obj = mappedObj(1);
      weeks.push(obj);
    }
    if (checkTerca) {
      const obj = mappedObj(2);
      weeks.push(obj);
    }
    if (checkQuarta) {
      const obj = mappedObj(3);
      weeks.push(obj);
    }
    if (checkQuinta) {
      const obj = mappedObj(4);
      weeks.push(obj);
    }
    if (checkSexta) {
      const obj = mappedObj(5);
      weeks.push(obj);
    }
    if (checkSabado) {
      const obj = mappedObj(6);
      weeks.push(obj);
    }
    if (checkDomingo) {
      const obj = mappedObj(7);
      weeks.push(obj);
    }

    if (weeks.length === 0 || !openHours || !closeHours) {
      setOpenErrorHours(true);
    }
    setRestrictionHours(weeks);
    clearFormRestrictionHours();
  };

  const getDisabledHours = (disable) => {
    const weekDisabled = restrictionHours.find((acc) => {
      return disable === acc.dayWeek;
    });

    if (weekDisabled) {
      return true;
    }

    return false;
  };

  const getWeekName = (value) => {
    if (value === 1) return 'Segunda';
    else if (value === 2) return 'Terça';
    else if (value === 3) return 'Quarta';
    else if (value === 4) return 'Quinta';
    else if (value === 5) return 'Sexta';
    else if (value === 6) return 'Sábado';
    else if (value === 7) return 'Domingo';
    else return '';
  };

  const removeRestrictionHours = (value) => {
    let hours = restrictionHours;
    hours.splice(value, 1);

    setRestrictionHours(hours);
  };

  const saveCupom = async (event) => {
    event.preventDefault();
    setLoading(true);
    setDisabledButton(true);
    const type = typeCupom === 0 ? 1 : 2;
    const firt = firstUse === 0 ? null : firstUse === 1 ? 1 : 2;
    const newDate = dateExpiration ? dateExpiration.toISOString() : null;
    const mappedHours =
      restrictionHours && restrictionHours.length > 0
        ? restrictionHours.map((acc) => {
          return {
            DiaDaSemana: acc.dayWeek,
            HoraAbertura: acc.openHour,
            HoraFechamento: acc.closeHour
          };
        })
        : [];
    const mappedEmails =
      emails && emails.length > 0
        ? emails.map((acc) => {
          return {
            Id: acc.id,
            Email: acc.name
          };
        })
        : [];

    const flagCategory = categoryMay && !categoryWillNotBeAble ? true : false;
    const arrayCategies =
      categories && !availableCategories && categories.length > 0
        ? categories.map((item) => {
          return {
            NomeCategoria: item.name,
            Participante: flagCategory
          };
        })
        : [];

    const flagProduct = productMay && !productWillNotBeAble ? true : false;
    const arrayProducts =
      products && !availableProducts && products.length > 0
        ? products.map((item) => {
          return {
            NomeProduto: item.name,
            Participante: flagProduct
          };
        })
        : [];

    const flagUser = userMay && !userWillNotBeAble ? true : false;
    const eatHere = checkEatHere
      ? {
        ApenasRestricao: true
      }
      : null;
    const kilo = checkKilo
      ? {
        ApenasRestricao: true
      }
      : null;
    const takeAlong = checkTakeAlong
      ? discountCheckTakeAlong
        ? {
          ApenasRestricao: false,
          TipoValorCupom: typeValueCupomAlong === 0 ? 1 : 2,
          Valor: valueAlong,
          ValorMinimoTaxa: valueMinAlong,
          ValorMaximoDescontoTaxa: valueMaxAlong
        }
        : { ApenasRestricao: true }
      : null;
    const toReceive = checkToReceive
      ? discountCheckToReceive
        ? {
          ApenasRestricao: false,
          TipoValorCupom: typeValueCupomReceive === 0 ? 1 : 2,
          Valor: valueReceive,
          ValorMinimoTaxa: valueMinReceive,
          ValorMaximoDescontoTaxa: valueMaxReceive
        }
        : { ApenasRestricao: true }
      : null;
    const delivery = checkDelivery
      ? discountCheckDelivery
        ? {
          ApenasRestricao: false,
          TipoValorCupom: typeValueCupomDelivery === 0 ? 1 : 2,
          Valor: valueDelivery,
          ValorMinimoTaxa: valueMinDelivery,
          ValorMaximoDescontoTaxa: valueMaxDelivery
        }
        : { ApenasRestricao: true }
      : null;

    const data = {
      Nome: name,
      Total: qtdTotal,
      TotalPorUsuario: totalUser,
      Aplicativo: storeInfo?.app.id,
      DataExpiracao: newDate,
      PrimeiroUso: firt,
      UsoGeral: visible,
      VisualizarListaLojas: false,
      TipoValorCupom: type,
      Valor: typeCupom === 0 ? parseFloat(cupomValue) : cupomValuePercentage,
      ValorMinimoTransacao: parseFloat(valueMin),
      ValorMaximoTransacao: parseFloat(valueMax),
      BreveDescricao: description,
      Descricao: description,
      RestricaoEstabelecimentos: establishments,
      RestricaoHorarios: mappedHours,
      ParticipanteRestricaoUsuarios: flagUser,
      RestricaoUsuarios: mappedEmails,
      ProdutosProibidos: arrayProducts,
      CategoriasProibidas: arrayCategies,
      ValoresModalidadeComerAqui: eatHere,
      ValoresModalidadeKilo: kilo,
      ValoresModalidadeQueroLevar: takeAlong,
      ValoresModalidadeReceberEscritorio: toReceive,
      ValoresModalidadeDelivery: delivery,
    };

    if (!dateExpiration) {
      setLoading(false);
      setOpenSubmitSuccess(true);
      setMessage('Error ao cadastrar o cupom. É necesário preencher todos os campos. (Data de expiração)');

      return;
    }

    const response = cupomId
      ? await dispatch(editCupom({ data, cupomId }))
      : await dispatch(postCupom(data));

    if (cupomId && response.success) {
      setLoading(false);
      setDisabledButton(false);
      clearForm();
      setOpenSubmitSuccess(true);
      setMessage(
        'Cupom alterado com sucesso. Para visualizar o cupom vá até a página de consulta.'
      );
    } else if (!cupomId && response.success) {
      setLoading(false);
      setDisabledButton(false);
      clearForm();
      setOpenSubmitSuccess(true);
      setMessage(
        'Cupom cadastrado com sucesso. Para visualizar o cupom vá até a página de consulta.'
      );
    } else {
      setLoading(false);
      setOpenSubmitSuccess(true);
      setMessage('Error ao cadastrar o cupom. Por favor tente novamente.');
    }
  };

  return (
    <Wrapper>
      <Col1>
        <Title>Cupons</Title>
        <Card>
          <form onSubmit={saveCupom}>
            {loading ? (
              <Loading />
            ) : (
              <>
                <SubCard>
                  <SubTitle>
                    <H4>Informações</H4>
                    <CustomIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setValueTab(0);
                      }}
                    >
                      <Icon
                        width={'16px'}
                        height={'16px'}
                        name={'infoCupom'}
                        stroke={'primary'}
                      />
                    </CustomIcon>
                  </SubTitle>
                  <Row>
                    <Field>
                      <CustomLabel>Nome</CustomLabel>
                      <Input
                        id="name"
                        name="name"
                        type="text"
                        value={name}
                        onChange={setName}
                        required
                        maxLength={150}
                      />
                      <Caption>
                        {name ? name.length : '0'}/150
                      </Caption>
                    </Field>
                    <Field>
                      <CustomLabel>Quantidade total de usos</CustomLabel>
                      <Input
                        id="quantity"
                        name="quantity"
                        type="text"
                        inputType="number"
                        maxLength="9"
                        value={qtdTotal}
                        onChange={setQtdTotal}
                        required
                      />
                    </Field>
                    <Field>
                      <CustomLabel>Total por usuario</CustomLabel>
                      <Input
                        id="total"
                        name="total"
                        type="text"
                        inputType="number"
                        maxLength="9"
                        value={totalUser}
                        onChange={setTotalUser}
                        required
                      />
                    </Field>
                  </Row>
                  <Row>
                    <Field>
                      <CustomLabel>Data da expiração</CustomLabel>
                      <DateInput
                        value={dateExpiration}
                        onChange={handleDateChange}
                      />
                    </Field>
                    <Field>
                      <CustomLabel>Primeiro uso</CustomLabel>
                      <SelectInput
                        options={optionsFirstUse}
                        selected={firstUse}
                        onSelect={setfirstUse}
                      />
                    </Field>
                  </Row>
                  <Row>
                    <Field>
                      <CheckboxWrapper>
                        <CheckboxHours
                          checked={visible}
                          onCheck={handleCheckVisible}
                        >
                          Tornar visível na sessão de cupom
                        </CheckboxHours>
                      </CheckboxWrapper>
                    </Field>
                  </Row>
                </SubCard>
                <SubCard>
                  <SubTitle>
                    <H4>Configurações do Valor</H4>
                    <CustomIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setValueTab(1);
                      }}
                    >
                      <Icon
                        width={'16px'}
                        height={'16px'}
                        name={'infoCupom'}
                        stroke={'primary'}
                      />
                    </CustomIcon>
                  </SubTitle>
                  <Row>
                    <Field>
                      <CustomLabel>Tipo de Valor Cupom</CustomLabel>
                      <SelectInput
                        options={optionsType}
                        selected={typeCupom}
                        onSelect={setTypeCupom}
                      />
                    </Field>
                    <Field>
                      <CustomLabel>Valor</CustomLabel>
                      {typeCupom === 0 ? (
                        <CurrencyNumeric
                          id="cupom-value"
                          name="cupomValue"
                          value={cupomValue}
                          onChange={setCupomValue}
                          required
                        />
                      ) : (
                        <PercentageNumeric
                          id="cupom-value"
                          name="cupomValue"
                          value={cupomValuePercentage}
                          onChange={setCupomValuePercentage}
                          required
                        />
                      )}
                    </Field>
                    <Field>
                      <CustomLabel>Valor mínimo por transações</CustomLabel>
                      <CurrencyNumeric
                        id="value-min"
                        name="valueMin"
                        value={valueMin}
                        onChange={setValueMin}
                        required
                      />
                    </Field>
                  </Row>
                  <Row>
                    <Field>
                      <CustomLabel>Valor máximo do desconto</CustomLabel>
                      <CurrencyNumeric
                        id="value-max"
                        disabled={typeCupom === 0 ? true : false}
                        name="valueMax"
                        value={valueMax}
                        onChange={setValueMax}
                        required
                      />
                    </Field>
                  </Row>
                </SubCard>
                <SubCard>
                  <SubTitle>
                    <H4>Descrição</H4>
                    <CustomIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setValueTab(2);
                      }}
                    >
                      <Icon
                        width={'16px'}
                        height={'16px'}
                        name={'infoCupom'}
                        stroke={'primary'}
                      />
                    </CustomIcon>
                  </SubTitle>
                  <Row>
                    <Input
                      multi={true}
                      rows="5"
                      id="description"
                      name="description"
                      value={description}
                      onChange={setDescription}
                      required
                      maxLength={150}
                    />
                  </Row>
                  <Caption>
                    {description ? description.length : '0'}/150
                  </Caption>
                </SubCard>
                <SubCard>
                  <SubTitle>
                    <H4>Restrições</H4>
                    <CustomIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setValueTab(3);
                      }}
                    >
                      <Icon
                        width={'16px'}
                        height={'16px'}
                        name={'infoCupom'}
                        stroke={'primary'}
                      />
                    </CustomIcon>
                  </SubTitle>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>
                          1. Disponível para todos <Strong>usuários</Strong>?
                        </CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableCheck"
                            defaultChecked={availableUsers}
                            onChange={handleAvailableCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableCheck"
                            defaultChecked={!availableUsers}
                            onChange={handleAvailableCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableUsers && (
                      <Row>
                        <Field className="restrictions">
                          <CustomLabel className="restrictions">
                            Qual tipo de restrição que você deseja utilizar?
                          </CustomLabel>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={userMay && !userWillNotBeAble}
                              onCheck={handleCheckMay}
                            >
                              Usuarios que poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={userWillNotBeAble && !userMay}
                              onCheck={handleUserWillNotBeAble}
                            >
                              Usuarios que não poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                        </Field>
                        <Field className="restrictions">
                          <CustomLabel>
                            <strong>Lista de usuários</strong>
                          </CustomLabel>
                          <CustomLabel className="restrictions">
                            Insira os <Strong>e-mails</Strong> dos usuários que deseja incluir na
                            lista
                          </CustomLabel>
                          <CustomAutoComplete
                            name="users"
                            setItems={setEmails}
                            fetchSelected={fetchUsers}
                            searchs={searchUsers}
                            setSearch={setSearchUsers}
                            defaultValue={emails}
                          />
                        </Field>
                      </Row>
                    )}
                  </Div>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>
                          2. Disponiveis em todos <Strong>estabelecimentos</Strong>?
                        </CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableEstablishmentsCheck"
                            defaultChecked={availableEstablishments}
                            onChange={handleAvailableEstablishmentsCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableEstablishmentsCheck"
                            defaultChecked={!availableEstablishments}
                            onChange={handleAvailableEstablishmentsCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableEstablishments && (
                      <Row>
                        <Field className="restrictions">
                          <CustomLabel>
                            <strong>Lista de estabelecimentos</strong>
                          </CustomLabel>
                          <CustomLabel className="restrictions">
                            Insira o <Strong>nome</Strong> dos estabelecimentos onde o cupom{' '}
                            <Strong>será válido</Strong>
                          </CustomLabel>
                          <CustomAutoComplete
                            name="stores"
                            setItems={setEstablishments}
                            fetchSelected={fetchStores}
                            searchs={searchStores}
                            setSearch={setSearchStores}
                            defaultValue={establishments}
                          />
                        </Field>
                      </Row>
                    )}
                  </Div>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>3. Disponíveis em todos os horários?</CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableHoursCheck"
                            defaultChecked={availableHours}
                            onChange={handleAvailableHoursCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableHoursCheck"
                            defaultChecked={!availableHours}
                            onChange={handleAvailableHoursCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableHours && (
                      <>
                        <Row>
                          <Field className="restrictions">
                            <CustomLabel>
                              <strong>Dia Válido</strong>
                            </CustomLabel>
                            <CustomLabel className="restrictions">
                              Selecione o dia que o cumpom estará ativo
                            </CustomLabel>
                          </Field>
                        </Row>
                        <Row className="check">
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(1)}
                              checked={checkSegunda}
                              onCheck={handleChangeSegunda}
                            >
                              Seg
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(2)}
                              checked={checkTerca}
                              onCheck={handleChangeTerca}
                            >
                              Ter
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(3)}
                              checked={checkQuarta}
                              onCheck={handleChangeQuarta}
                            >
                              Qua
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(4)}
                              checked={checkQuinta}
                              onCheck={handleChangeQuinta}
                            >
                              Qui
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(5)}
                              checked={checkSexta}
                              onCheck={handleChangeSexta}
                            >
                              Sex
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(6)}
                              checked={checkSabado}
                              onCheck={handleChangeSabado}
                            >
                              Sab
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              disabled={getDisabledHours(7)}
                              checked={checkDomingo}
                              onCheck={handleChangeDomingo}
                            >
                              Dom
                            </CheckboxHours>
                          </CheckboxWrapper>
                        </Row>
                        <Row>
                          <Field className="restrictions">
                            <CustomLabel>
                              <strong>Horário Válido</strong>
                            </CustomLabel>
                            <CustomLabel className="restrictions">
                              Selecione a faixa de horário que o cumpom estará ativo
                            </CustomLabel>
                          </Field>
                        </Row>
                        <Row>
                          <Span>Das</Span>
                          <FieldWrapper>
                            <TimeInputHours
                              value={openHours}
                              onChange={handleFrom}
                            />
                          </FieldWrapper>
                          <Span>às</Span>
                          <FieldWrapper>
                            <TimeInputHours
                              value={closeHours}
                              onChange={handleTo}
                            />
                          </FieldWrapper>
                          <NewHoursButton
                            type="button"
                            className="primary"
                            onClick={handleAddRestrictionHors}
                          >
                            Adicionar
                          </NewHoursButton>
                        </Row>
                        <hr />
                        <Row>
                          <CustomLabel>
                            <strong>Tabela de funcionamento</strong>
                          </CustomLabel>
                          <Table>
                            <Thead>
                              <Tr>
                                <Th>Dia</Th>
                                <Th>Horário</Th>
                                <Th>Ação</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {restrictionHours &&
                                restrictionHours.map((restriction, index) => {
                                  return (
                                    <Tr key={index}>
                                      <Td>{getWeekName(restriction.dayWeek)}</Td>
                                      <Td>
                                        {restriction.openHour} às {restriction.closeHour}
                                      </Td>
                                      <Td>
                                        <CustomIcon onClick={() => removeRestrictionHours(index)}>
                                          <Icon
                                            width={'16px'}
                                            height={'16px'}
                                            name={'trash'}
                                            stroke={'primary'}
                                            fill={'primary'}
                                          />
                                        </CustomIcon>
                                      </Td>
                                    </Tr>
                                  );
                                })}
                              {restrictionHours.length === 0 && (
                                <Tr>
                                  <td colspan="3">
                                    <Alert severity="info">
                                      Selecione um dia e um horário válido!
                                    </Alert>
                                  </td>
                                </Tr>
                              )}
                            </Tbody>
                          </Table>
                        </Row>
                      </>
                    )}
                  </Div>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>
                          4. Aplicavel em todas as <Strong>categorias</Strong>?
                        </CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableCategoriesCheck"
                            defaultChecked={availableCategories}
                            onChange={handleAvailableCategoriesCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableCategoriesCheck"
                            defaultChecked={!availableCategories}
                            onChange={handleAvailableCategoriesCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableCategories && (
                      <Row>
                        <Field className="restrictions">
                          <CustomLabel className="restrictions">
                            Qual tipo de restrição que você deseja utilizar?
                          </CustomLabel>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={categoryMay && !categoryWillNotBeAble}
                              onCheck={handleChangeCategoryMay}
                            >
                              Categorias que poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={categoryWillNotBeAble && !categoryMay}
                              onCheck={handleCategoryWillNotBeAble}
                            >
                              Categorias que não poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                        </Field>
                        <Field className="restrictions">
                          <CustomLabel>
                            <strong>Lista de categorias</strong>
                          </CustomLabel>
                          <CustomLabel className="restrictions">
                            Insira o <Strong>Nome</Strong> das categorias onde o cupom{' '}
                            <Strong>{categoryMay && !categoryWillNotBeAble ? 'será válido' : 'não será válido'}</Strong>
                          </CustomLabel>
                          <CustomAutoComplete
                            name="restrictions"
                            setItems={setCategories}
                            fetchSelected={fetchCategoriesByName}
                            searchs={searchCategories}
                            setSearch={setSearchCategories}
                            defaultValue={categories}
                            storeId={selectedMultistore}
                          />
                        </Field>
                      </Row>
                    )}
                  </Div>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>
                          5. Aplicavel em todos <Strong>produtos do cardápio</Strong>?
                        </CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableProductsCheck"
                            defaultChecked={availableProducts}
                            onChange={handleAvailableProductsCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableProductsCheck"
                            defaultChecked={!availableProducts}
                            onChange={handleAvailableProductsCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableProducts && (
                      <Row>
                        <Field className="restrictions">
                          <CustomLabel className="restrictions">
                            Qual tipo de restrição que você deseja utilizar?
                          </CustomLabel>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={productMay && !productWillNotBeAble}
                              onCheck={handleChangeProductMay}
                            >
                              Produtos que poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={productWillNotBeAble && !productMay}
                              onCheck={handleProductWillNotBeAble}
                            >
                              Produtos que não poderão usar o cupom criado
                            </CheckboxHours>
                          </CheckboxWrapper>
                        </Field>
                        <Field className="restrictions">
                          <CustomLabel>
                            <strong>Lista de produtos</strong>
                          </CustomLabel>
                          <CustomLabel className="restrictions">
                            Insira o <Strong>Nome</Strong> dos produtos onde o cupom{' '}
                            <Strong>{productMay && !productWillNotBeAble ? 'será válido' : 'não será válido'}</Strong>
                          </CustomLabel>
                          <CustomAutoComplete
                            name="restrictions"
                            setItems={setProducts}
                            fetchSelected={fetchProductsByName}
                            searchs={searchProducts}
                            setSearch={setSearchProducts}
                            defaultValue={products}
                            storeId={selectedMultistore}
                          />
                        </Field>
                      </Row>
                    )}
                  </Div>
                  <Div>
                    <Row>
                      <Field>
                        <CustomLabel>
                          6. Disponivel em todas as <Strong>modalidades</Strong>?
                        </CustomLabel>
                        <RadioGroup>
                          <RadioButton
                            value={'true'}
                            name="availableModalityCheck"
                            defaultChecked={availableModality}
                            onChange={handleAvailableModalityCheck}
                          >
                            Sim
                          </RadioButton>
                          <RadioButton
                            value={'false'}
                            name="availableModalityCheck"
                            defaultChecked={!availableModality}
                            onChange={handleAvailableModalityCheck}
                          >
                            Não
                          </RadioButton>
                        </RadioGroup>
                      </Field>
                    </Row>
                    {!availableModality && (
                      <>
                        <Row>
                          <Field className="restrictions">
                            <CustomLabel>
                              <strong>Modalidades Válidas</strong>
                            </CustomLabel>
                            <CustomLabel className="restrictions">
                              Selecione a modalidade onde o cupom será válido
                            </CustomLabel>
                          </Field>
                        </Row>
                        <Row className="check">
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={checkTakeAlong}
                              onCheck={handleChangeAlonge}
                            >
                              Quero levar
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={checkToReceive}
                              onCheck={handleChangeReceive}
                            >
                              Receber no escritório
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={checkDelivery}
                              onCheck={handleChangeDelivery}
                            >
                              Delivery
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={checkEatHere}
                              onCheck={handleChangeEatHere}
                            >
                              Comer aqui
                            </CheckboxHours>
                          </CheckboxWrapper>
                          <CheckboxWrapper>
                            <CheckboxHours
                              checked={checkKilo}
                              onCheck={handleChangeKilo}
                            >
                              Kilo
                            </CheckboxHours>
                          </CheckboxWrapper>
                        </Row>
                        {checkTakeAlong && (
                          <Div>
                            <CustomLabel className="bottom-line">
                              <strong>Quero Levar</strong>
                            </CustomLabel>
                            <Row className="check">
                              <CheckboxWrapper>
                                <CheckboxHours
                                  checked={discountCheckTakeAlong}
                                  onCheck={handleChangeDiscontAlonge}
                                >
                                  Habilitar desconto sobre taxa
                                </CheckboxHours>
                              </CheckboxWrapper>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Tipo Valor Cupom</CustomLabel>
                                <SelectInput
                                  options={optionsType}
                                  selected={typeValueCupomAlong}
                                  onSelect={setTypeValueCupomAlong}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor</CustomLabel>
                                <Input
                                  id="valueAlong"
                                  name="valueAlong"
                                  type="text"
                                  value={valueAlong}
                                  onChange={setValueAlong}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor mínimo por transações</CustomLabel>
                                <Input
                                  id="value-min"
                                  name="valueMin"
                                  type="text"
                                  value={valueMinAlong}
                                  onChange={setValueMinAlong}
                                />
                              </Field>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Valor máximo do desconto</CustomLabel>
                                <Input
                                  id="value-max"
                                  name="valueMax"
                                  disabled={typeValueCupomAlong === 0 ? true : false}
                                  type="text"
                                  value={valueMaxAlong}
                                  onChange={setValueMaxAlong}
                                />
                              </Field>
                            </Row>
                          </Div>
                        )}
                        {checkToReceive && (
                          <Div>
                            <CustomLabel className="bottom-line">
                              <strong>Receber no Escritório</strong>
                            </CustomLabel>
                            <Row className="check">
                              <CheckboxWrapper>
                                <CheckboxHours
                                  checked={discountCheckToReceive}
                                  onCheck={handleChangeDiscontReceive}
                                >
                                  Habilitar desconto sobre taxa
                                </CheckboxHours>
                              </CheckboxWrapper>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Tipo Valor Cupom</CustomLabel>
                                <SelectInput
                                  options={optionsType}
                                  selected={typeValueCupomReceive}
                                  onSelect={setTypeValueCupomReceive}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor</CustomLabel>
                                <Input
                                  id="valueReceive"
                                  name="valueReceive"
                                  type="text"
                                  value={valueReceive}
                                  onChange={setValueReceive}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor mínimo por transações</CustomLabel>
                                <Input
                                  id="value-min"
                                  name="valueMin"
                                  type="text"
                                  value={valueMinReceive}
                                  onChange={setValueMinReceive}
                                />
                              </Field>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Valor máximo do desconto</CustomLabel>
                                <Input
                                  id="value-max"
                                  name="valueMax"
                                  disabled={typeValueCupomReceive === 0 ? true : false}
                                  type="text"
                                  value={valueMaxReceive}
                                  onChange={setValueMaxReceive}
                                />
                              </Field>
                            </Row>
                          </Div>
                        )}
                        {checkDelivery && (
                          <Div>
                            <CustomLabel className="bottom-line">
                              <strong>Delivery</strong>
                            </CustomLabel>
                            <Row className="check">
                              <CheckboxWrapper>
                                <CheckboxHours
                                  checked={discountCheckDelivery}
                                  onCheck={handleChangeDiscontDelivery}
                                >
                                  Habilitar desconto sobre taxa
                                </CheckboxHours>
                              </CheckboxWrapper>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Tipo Valor Cupom</CustomLabel>
                                <SelectInput
                                  options={optionsType}
                                  selected={typeValueCupomDelivery}
                                  onSelect={setTypeValueCupomDelivery}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor</CustomLabel>
                                <Input
                                  id="valueDelivery"
                                  disable={discountCheckDelivery}
                                  name="valueDelivery"
                                  type="text"
                                  value={valueDelivery}
                                  onChange={setValueDelivery}
                                />
                              </Field>
                              <Field>
                                <CustomLabel>Valor mínimo por transações</CustomLabel>
                                <Input
                                  id="value-min"
                                  name="valueMin"
                                  type="text"
                                  value={valueMinDelivery}
                                  onChange={setValueMinDelivery}
                                />
                              </Field>
                            </Row>
                            <Row>
                              <Field>
                                <CustomLabel>Valor máximo do desconto</CustomLabel>
                                <Input
                                  id="value-max"
                                  name="valueMax"
                                  disabled={typeValueCupomDelivery === 0 ? true : false}
                                  type="text"
                                  value={valueMaxDelivery}
                                  onChange={setValueMaxDelivery}
                                />
                              </Field>
                            </Row>
                          </Div>
                        )}
                      </>
                    )}
                  </Div>
                </SubCard>
              </>
            )}
            <DivButtonSave>
              <SaveButton
                type="submit"
                disabled={disabledButton}
                className="primary"
              >
                Salvar cupom
              </SaveButton>
            </DivButtonSave>
          </form>
        </Card>
      </Col1>

      <Dialog
        open={openErrorHours}
        onClose={handleCloseError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Span>
            Para adicionar um horario a restrição é preciso selecionar pelo menos um dia da semana,
            adicionar um horario inicial e final.
          </Span>
        </DialogContent>
        <DialogActions>
          <NewHoursButton
            className="primary"
            onClick={handleCloseError}
          >
            Ok entendi!
          </NewHoursButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSubmitSuccess}
        onClose={handleCloseSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Span>{message}</Span>
        </DialogContent>
        <DialogActions>
          <NewHoursButton
            className="primary"
            onClick={handleCloseSuccess}
          >
            Ok entendi!
          </NewHoursButton>
        </DialogActions>
      </Dialog>
      <CoupousInfo
        value={valueTab}
        setValue={setValueTab}
        open={openModalInfo}
        setOpen={setOpenModalInfo}
      />
    </Wrapper>
  );
};

export default CouponsCreatePage;
